import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import { useMutation, gql } from '@apollo/client'
import { Box, Button, IconButton, Input, InputAdornment } from '@mui/material'
import LockOutlined from '@mui/icons-material/LockOutlined'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import Header from '../../components/Headers/Header'
import { SectionCard, raisedButtonSx } from '../../components/UI/Depth'
import { influencerSidebarIcons } from '../../components/Sidebar/sidebarIcons'
import { updateInfluencerProfile } from '../../apollo'
import useGlobalStyles from '../../utils/globalStyles'
import { FieldLabel, FormFeedback } from './shared'

const UPDATE_PROFILE = gql`
  ${updateInfluencerProfile}
`

function InfluencerSettings(props) {
  const { t } = props
  const globalClasses = useGlobalStyles()
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [success, setSuccess] = useState('')
  const [error, setError] = useState('')

  const [mutate, { loading }] = useMutation(UPDATE_PROFILE, {
    onCompleted: () => {
      setPassword('')
      setConfirm('')
      setError('')
      setSuccess(t('PasswordUpdated'))
      setTimeout(() => setSuccess(''), 4000)
    },
    onError: err => {
      setSuccess('')
      setError(err.message)
      setTimeout(() => setError(''), 5000)
    }
  })

  const onSubmit = event => {
    event.preventDefault()
    if (password.length < 6) {
      setError(t('PasswordTooShort'))
      return
    }
    if (password !== confirm) {
      setError(t('PasswordsDoNotMatch'))
      return
    }
    mutate({ variables: { password } })
  }

  const visibilityToggle = (
    <InputAdornment position="end">
      <IconButton
        size="small"
        onClick={() => setShowPassword(!showPassword)}
        aria-label="toggle password visibility">
        {showPassword ? (
          <VisibilityIcon fontSize="small" />
        ) : (
          <VisibilityOffIcon fontSize="small" />
        )}
      </IconButton>
    </InputAdornment>
  )

  return (
    <>
      <Header
        title={t('Settings')}
        subtitle={t('SubtitleInfluencerSettings')}
        icon={influencerSidebarIcons.Settings}
      />
      <SectionCard
        icon={LockOutlined}
        tone="slate"
        title={t('ChangePassword')}
        subtitle={t('PasswordTooShort')}
        sx={{ maxWidth: 620 }}
        bodySx={{ pt: 2.5 }}>
        <form onSubmit={onSubmit}>
          <FieldLabel>{t('NewPassword')}</FieldLabel>
          <Input
            id="input-new-password"
            name="input-new-password"
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={e => setPassword(e.target.value)}
            disableUnderline
            className={globalClasses.input}
            endAdornment={visibilityToggle}
          />
          <Box mt={2}>
            <FieldLabel>{t('ConfirmPassword')}</FieldLabel>
            <Input
              id="input-confirm-password"
              name="input-confirm-password"
              type={showPassword ? 'text' : 'password'}
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              disableUnderline
              className={globalClasses.input}
            />
          </Box>
          <Box mt={3}>
            <Button type="submit" disabled={loading} sx={raisedButtonSx}>
              {t('Save')}
            </Button>
          </Box>
        </form>
        <FormFeedback success={success} error={error} />
      </SectionCard>
    </>
  )
}

export default withTranslation()(InfluencerSettings)
